// Wallet accessible via dialog only (click on wallet icon in HomePage)
// No direct routes - use wallet:details_requested event to open dialog

export default [];
